import React from "react";
import { Card, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";

type HeaderCardProps = {
  name: string | React.JSX.Element;
  trailing?: React.JSX.Element;
  testID?: string;
};

export function HeaderCard({
  name,
  trailing,
  testID = "header-card",
}: HeaderCardProps) {
  return (
    <Card className={styles.wrapper} testID={testID}>
      <div className={styles.name}>
        <Text style="global/heading-large">{name}</Text>
      </div>

      {trailing}
    </Card>
  );
}

const styles = {
  wrapper: css({
    borderRadius: "var(--border-radius-4)",
    display: "flex",
    padding: "var(--space-4)",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  name: css({
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
  }),
};
